import React from 'react';

// Detecta texto del tipo "<intro>. <frase con ':'> 1) item1. 2) item2." y lo
// separa en intro + frase introductoria + lista de items numerados.
// Si no detecta lista, devuelve el texto tal cual como `intro`.
function parseScenarioDescription(text) {
    if (!text) return { intro: '', listIntro: '', items: [] };

    const re = /(?:^|\s)(\d+)[\)\.]\s+/g;
    const matches = [...text.matchAll(re)];
    if (matches.length < 2) return { intro: text.trim(), listIntro: '', items: [] };

    const firstIdx = matches[0].index + matches[0][0].indexOf(matches[0][1]);
    const before = text.slice(0, firstIdx);
    const colonIdx = before.lastIndexOf(':');

    let intro = '';
    let listIntro = '';
    if (colonIdx > 0) {
        const beforeColon = before.slice(0, colonIdx);
        const sentBoundary = beforeColon.search(/\.\s+(?=[A-ZÁÉÍÓÚÑ¿¡])(?:[^.]*)$/);
        if (sentBoundary >= 0) {
            intro = text.slice(0, sentBoundary + 1).trim();
            listIntro = before.slice(sentBoundary + 1, colonIdx + 1).trim();
        } else {
            listIntro = before.slice(0, colonIdx + 1).trim();
        }
    } else {
        intro = before.trim();
    }

    const items = [];
    for (let i = 0; i < matches.length; i++) {
        const start = matches[i].index + matches[i][0].length;
        const end = i + 1 < matches.length ? matches[i + 1].index : text.length;
        const raw = text.slice(start, end).trim().replace(/[\s.,;]+$/, '');
        if (raw) items.push(raw);
    }

    return { intro, listIntro, items };
}

// Render flexible: hereda el tamaño/color del padre vía `className`.
// `accent` controla el color del badge numérico.
export default function ScenarioDescription({ text, className = '', accent = '#1A4731' }) {
    const { intro, listIntro, items } = parseScenarioDescription(text || '');

    if (!items.length) {
        return <p className={`leading-relaxed ${className}`}>{text}</p>;
    }

    return (
        <div className={`leading-relaxed ${className}`}>
            {intro && <p>{intro}</p>}
            {listIntro && (
                <p className={`font-semibold text-stone-700 ${intro ? 'mt-3' : ''}`}>{listIntro}</p>
            )}
            <ol className={`space-y-1.5 ${(intro || listIntro) ? 'mt-2' : ''}`}>
                {items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                        <span
                            className="shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold text-white mt-0.5"
                            style={{ background: accent }}
                        >
                            {i + 1}
                        </span>
                        <span className="flex-1">{item}</span>
                    </li>
                ))}
            </ol>
        </div>
    );
}
